import React from 'react';
import { Paper } from '@material-ui/core';
import styled from 'styled-components';
import NewOperationForm from 'components/NewOperationForm';

const StyledPaper = styled(Paper)`
  padding: 2rem;
  margin: auto;
  width: 60vw;
  max-height: 90vh;
  overflow: auto;
  text-align: center;
  border: 2px solid #000;
  box-shadow: ${(p) => p.theme.shadows[5]};
`;

function NewOperationModal(props) {
  return (
    <StyledPaper elevation={3}>
      <NewOperationForm {...props} />
    </StyledPaper>
  );
}

export default NewOperationModal;
